import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CheckCircleFilled } from "@ant-design/icons";
import { Result, Row } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DEFAULT_LANGUAGE, ESupportedLanguage, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useStatisticsExtraColumns } from "./columns.js";
import { useContentBlockerTemplateMetaData } from "../../../../hooks/content-blocker/useContentBlockerTemplateMetaData.js";
import { useServiceTemplateMetaData } from "../../../../hooks/service/useServiceTemplateMetaData.js";
import { useTranslation } from "../../../../others/i18n.js";
import { spacing } from "../../../../styles/spacing.js";
import { TemplateMetaDataTable } from "../template/meta-data/templateMetaDataTable.js";
function StatisticsExpansion(props) {
    const { t } = useTranslation();
    const { tableData } = props;
    const navigate = useNavigate();
    const isDefaultLanguage = tableData.language === DEFAULT_LANGUAGE;
    const [missingContentBlockerIdentifier, setMissingContentBlockerIdentifier] = useState([]);
    const contentBlockersWithMissingTranslations = useContentBlockerTemplateMetaData(missingContentBlockerIdentifier.length > 0, false, tableData?.calculatedIdentifier?.contentBlockerIdentifier);
    const [missingServiceIdentifier, setMissingServiceIdentifier] = useState([]);
    const servicesWithMissingTranslations = useServiceTemplateMetaData(missingServiceIdentifier.length > 0, false, false, missingServiceIdentifier);
    useEffect(()=>{
        setMissingContentBlockerIdentifier(tableData?.calculatedIdentifier?.contentBlockerIdentifier || []);
        setMissingServiceIdentifier(tableData?.calculatedIdentifier?.serviceIdentifier || []);
    }, [
        tableData
    ]);
    const hasNoServiceTranslations = !servicesWithMissingTranslations.data || servicesWithMissingTranslations.data?.length === 0;
    const hasNoBlockerTranslations = !contentBlockersWithMissingTranslations.data || contentBlockersWithMissingTranslations.data?.length === 0;
    const extraColumnServices = useStatisticsExtraColumns(tableData, t, "Service");
    const extraColumnBlockers = useStatisticsExtraColumns(tableData, t, "Content-Blocker");
    const paginationConfig = {
        defaultPageSize: 10,
        hideOnSinglePage: true
    };
    const search = new URLSearchParams();
    search.append("stickyTranslationMode", "true");
    search.append("translationMode", "true");
    search.append("sourceLanguage", ESupportedLanguage.en);
    search.append("targetLanguage", tableData.language);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            hasNoBlockerTranslations && hasNoServiceTranslations || isDefaultLanguage ? /*#__PURE__*/ _jsx(Result, {
                status: "success",
                icon: /*#__PURE__*/ _jsx(CheckCircleFilled, {}),
                subTitle: isDefaultLanguage ? t("Default language. Therefore no translations are needed.") : t("All necessary translatable words are translated."),
                style: {
                    padding: spacing.layout.content.padding
                }
            }) : null,
            !isDefaultLanguage && !hasNoServiceTranslations ? /*#__PURE__*/ _jsx(TemplateMetaDataTable, {
                tableTitle: {
                    title: t("Service templates"),
                    props: {
                        level: 5
                    }
                },
                loading: servicesWithMissingTranslations.isFetching,
                templateMetaData: servicesWithMissingTranslations.data,
                hiddenColumns: [
                    TemplateMetaDataField.Extends,
                    TemplateMetaDataField.TranslationInfo
                ],
                extraColumns: extraColumnServices,
                actions: {
                    onEdit: (template)=>{
                        const editPath = `/rcb/service/edit/${template.identifier}`;
                        navigate({
                            pathname: editPath,
                            search: search.toString()
                        });
                    },
                    favouriteToggleHidden: true
                },
                pagination: paginationConfig,
                size: "small"
            }) : null,
            /*#__PURE__*/ _jsx(Row, {
                style: {
                    paddingBottom: spacing.layout.content.paddingMedium
                }
            }),
            !isDefaultLanguage && !hasNoBlockerTranslations ? /*#__PURE__*/ _jsx(TemplateMetaDataTable, {
                tableTitle: {
                    title: t("Content Blocker"),
                    props: {
                        level: 5
                    }
                },
                loading: contentBlockersWithMissingTranslations.isFetching,
                templateMetaData: contentBlockersWithMissingTranslations.data,
                hiddenColumns: [
                    TemplateMetaDataField.Extends,
                    TemplateMetaDataField.TranslationInfo
                ],
                extraColumns: extraColumnBlockers,
                actions: {
                    onEdit: (template)=>{
                        const editPath = `/rcb/content-blocker/edit/${template.identifier}`;
                        navigate({
                            pathname: editPath,
                            search: search.toString()
                        });
                    },
                    favouriteToggleHidden: true
                },
                pagination: paginationConfig,
                size: "small"
            }) : null
        ]
    });
}
export { StatisticsExpansion };
